import { FC } from "react";
import { CustomerApplicationTask } from "@goodfill/domain-customer-application-types/src/customerApplicationSubmission";
import { Span } from "@goodfill/ui-components";

export const ApplicationPendingTask: FC<{ task: CustomerApplicationTask }> = ({ task }) => (
  <div key={`pending-task-${task.taskNumber}`} className="flex flex-col w-full border-b border-neutral-110 mb-4">
    {Object.keys(task).map((key) => {
      const taskValue = task[key as keyof CustomerApplicationTask];
      return (
        <div className="flex justify-between">
          <Span font={"semibold"}>{key}</Span>
          <Span>{taskValue.toString()}</Span>
        </div>
      );
    })}
  </div>
);
